
import { defineComponent, PropType } from 'vue'

interface RepositoryGroup {
  name?: string
  slug?: string
}

export default defineComponent({
  name: 'GroupManagedAlert',
  props: {
    repositoryGroup: {
      type: Object as PropType<RepositoryGroup>,
      required: true
    }
  }
})
